import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '产品',
    links: [
      { href: '/', label: '首页' },
      { href: '/category/product-updates', label: '产品动态' },
      { href: '/about', label: '关于我们' },
    ],
  },
  {
    title: '内容',
    links: [
      { href: '/category/browser-tips', label: '浏览器技巧' },
      { href: '/category/security-guide', label: '安全指南' },
      { href: '/category/internet-trends', label: '互联网资讯' },
    ],
  },
  {
    title: '支持',
    links: [
      { href: '/about#contact', label: '联系我们' },
      { href: '/about', label: '品牌介绍' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center gap-2.5 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <span className="text-background-50 font-bold text-sm font-label">91</span>
                </div>
                <span className="font-heading font-semibold text-base text-foreground-50">
                  91网页浏览器
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                极速、安全、稳定的网页浏览体验，让您的每一次上网都更加高效。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="font-heading font-semibold text-sm text-foreground-200 mb-4">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {group.links.map((link) => (
                    <li key={link.href + link.label}>
                      <Link
                        to={link.href}
                        className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-foreground-500">
              &copy; 2026 91网页浏览器. 保留所有权利.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">隐私政策</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">服务条款</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">Cookie设置</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}